export const ROLES_TABLE_DATA_COLUMNS = [
  "LIST",
  "SHOW",
  "CREATE",
  "EDIT",
  "DELETE",
  "CUSTOM",
] as const;
